import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M20.6 19.3l-3-3c-.1-.1-.2-.2-.3-.2 1-1.4 1.7-3.1 1.7-5C19 6.6 15.4 3 11 3s-8 3.6-8 8.1 3.6 8.1 8 8.1c1.9 0 3.6-.7 5-1.8 0 .1.1.2.2.3l3 3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4zM11 17.2c-3.3 0-6-2.7-6-6.1C5 7.7 7.7 5 11 5s6 2.7 6 6.1c0 3.4-2.7 6.1-6 6.1z" />,
  'Search'
)
